module.exports = __webpack_public_path__ + "RelaxBodyandMind-d1adcb44174829b537c183d816250800.png";